import controller from './vd-id-badge-title.controller'
/**
 * VdIdBadgeTitle Component
 */
export default {
  controller,
}
